<template>
  <div class="wrap" ref="newsDetail" id="wrap">
    <div v-if="!showDetail && !showSite && !showFloor && !showNearby">
      <div class="head">
        <van-sticky>
          <van-nav-bar
            class="defaultNav"
            :title="detailsInfo.projectName"
            ref="mtHeader"
            v-if="RouteInfo.single"
          />
          <van-nav-bar
            class="defaultNav"
            :title="detailsInfo.projectName"
            left-text
            left-arrow
            ref="mtHeader"
            v-else
            @click-left="$router.go(-1)"
          />
        </van-sticky>
      </div>
      <nav class="top">
        <div class="logo-box">
          <img class="logo" :src="img_url + agentData.brokeLogo" alt="" />
          <span>{{ agentData.licenceNo }}</span>
        </div>
        <img
          @click="menusShow = true"
          class="menus"
          src="../assets/img/menus.png"
          alt=""
        />
      </nav>
      <!-- <div class="app-pop">
        <img src="../assets/img/c_logo.png" width="38" height="38" alt="">
        <div class="app-right">
          <p>Search new projects easily on Ecoprop app</p>
          <div @click="Tolink()">
            Open the APP
          </div>
        </div>
      </div> -->
      <div class="agent-info-wrap">
        <div class="agent-info-box">
          <span
            class="agent-headshot"
            :style="{
              backgroundImage: 'url(' + img_url + agentData.logo + ')'
            }"
          ></span>
          <div class="agent-info">
            <p class="agent-name">{{ agentData.agentName }}</p>
            <p class="regnum">{{ agentData.regNum }}</p>
            <div class="mobile-box">
              <p class="agent-mobile">
                <span class="mobile-img"></span>
                <a :href="`tel:${agentData.mobile}`">{{ agentData.mobile }}</a>
              </p>
              <p class="agent-mobile">
                <span class="email-img"></span>
                <a :href="`mailto:${agentData.email}`">Email</a>
              </p>
              <p class="agent-mobile">
                <span class="whatsapp-img"></span>
                <a target="_blank" :href="`https://wa.me/${whatsapp}`"
                  >WhatsApp</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="menus-mask" v-if="menusShow">
        <div class="close-menus" @click.prevent="menusShow = false"></div>
        <ul class="menu-list">
          <li
            class="menu-item"
            :class="{ active: navgatorIndex == 'Description' }"
            v-if="detailsInfo.description"
            @click="toScroll('Description')"
          >
            <span>Description</span>
          </li>
          <li
            class="menu-item"
            :class="{ active: navgatorIndex == 'Gallery' }"
            v-if="MediaData.img && MediaData.img.length > 0"
            @click="toScroll('Gallery')"
          >
            <span>Gallery</span>
          </li>
          <li
            class="menu-item"
            :class="{ active: navgatorIndex == 'SiteFloorPlan' }"
            v-if="sitePlanImg && sitePlanImg.length > 0"
            @click="toScroll('SiteFloorPlan')"
          >
            <span>Site and Floor Plan</span>
          </li>
          <li
            class="menu-item"
            :class="{ active: navgatorIndex == 'Elevation' }"
            v-if="ElevationChartImg && ElevationChartImg.length > 0"
            @click="toScroll('Elevation')"
          >
            Elevation chart
          </li>
          <li
            class="menu-item"
            :class="{ active: navgatorIndex == 'Facilities' }"
            v-if="detailsInfo.nearbyAmenities"
            @click="toScroll('Facilities')"
          >
            Nearby Amenities
          </li>
          <li
            class="menu-item"
            :class="{ active: navgatorIndex == 'Calculator' }"
            v-if="calcUrl"
            @click="toScroll('Calculator')"
          >
            Calculator
          </li>
          <li
            class="menu-item"
            :class="{ active: navgatorIndex == 'Register' }"
            @click="toScroll('Register')"
          >
            Register
          </li>
        </ul>
      </div>
      <div class="content-wrap">
        <div
          v-if="detailsInfo.mainImage"
          class="main-img-box"
          :style="{
            backgroundImage: 'url(' + img_url + detailsInfo.mainImage + ')'
          }"
        >
          <p class="project-name">{{ detailsInfo.projectName }}</p>
        </div>
        <div
          v-else
          class="main-img-box"
          :style="{ backgroundImage: backgroundImage }"
        >
          <p class="project-name">{{ detailsInfo.projectName }}</p>
        </div>

        <div class="main">
          <div class="client-box">
            <!-- <h1 class="client-title">Dear Valued Client</h1>
            <p class="client-content">I am elated to share with you on this potential development {{detailsInfo.projectName}} with you. Please do not hesitate to enquire more or arrange an appointment with me. I look forward to hear from you soon, thank you!</p> -->
            <h2 class="project-name">Project Information</h2>
            <van-row>
              <van-col span="6">Developer</van-col>
              <van-col class="van-ellipsis" span="14">{{
                detailsInfo.developer
              }}</van-col>
            </van-row>
            <van-row>
              <van-col span="6">Type</van-col>
              <van-col class="van-ellipsis" span="14">{{
                detailsInfo.projectType
              }}</van-col>
            </van-row>
            <van-row>
              <van-col span="6">Total</van-col>
              <van-col class="van-ellipsis" span="14">{{
                detailsInfo.unitsNum
              }}</van-col>
            </van-row>
            <van-row>
              <van-col span="6">EXP Top</van-col>
              <van-col class="van-ellipsis" span="14">{{
                detailsInfo.expTop
              }}</van-col>
            </van-row>
            <van-row>
              <van-col span="6">Address</van-col>
              <van-col class="van-ellipsis" span="14">{{
                detailsInfo.streetAddress
              }}</van-col>
            </van-row>
            <van-row>
              <van-col span="6">Location</van-col>
              <van-col class="van-ellipsis" span="14">{{
                detailsInfo.location
              }}</van-col>
            </van-row>
            <van-row>
              <van-col span="6">Country</van-col>
              <van-col class="van-ellipsis" span="14">{{
                detailsInfo.country
              }}</van-col>
            </van-row>
            <van-row>
              <van-col span="6">Tenure</van-col>
              <van-col class="van-ellipsis" span="14">{{
                detailsInfo.tenure
              }}</van-col>
            </van-row>
          </div>
          <div
            class="description-box"
            id="Description"
            v-if="detailsInfo.description"
          >
            <h1>DESCRIPTION</h1>
            <div class="descriptionDiv" v-html="detailsInfo.description"></div>
          </div>

          <div
            class="gallery-box relation"
            id="Gallery"
            v-if="MediaData.img && MediaData.img.length > 0"
          >
            <h1>Gallery</h1>
            <div class="img-box">
              <el-image
                v-for="(item, index) in MediaData.img.slice(0, 4)"
                :key="index"
                :src="img_url + item.url"
                :class="{
                  'margin-left': (index - 0 + 1) % 2 == 0,
                  'margin-top': index > 1
                }"
                @click="previewMeaiaImg(MediaData.img.slice(0, 4), index)"
              >
                <div slot="error">
                  Load Fail
                </div>
              </el-image>
            </div>
            <img
              class="more"
              @click="showDetailClick('gallery')"
              src="../assets/img/right-row.png"
              alt=""
            />
          </div>

          <div
            class="virtual-wrap relation"
            v-if="MediaData.ivt && MediaData.ivt.length > 0"
          >
            <h1>Virtual Tour</h1>
            <div class="virtual-box">
              <div
                class="img-box"
                v-for="(item, index) in MediaData.ivt.slice(0, 4)"
                :key="index"
                :class="{
                  'margin-top': index >= 2,
                  'margin-top-ipad': index >= 1
                }"
              >
                <img :src="img_url + item.url" alt="" />
                <span class="iconSpn" @click="goFileLink(item)"></span>
              </div>
            </div>
            <img
              class="more"
              @click="showDetailClick('virtualTour')"
              src="../assets/img/right-row.png"
              alt=""
            />
          </div>

          <div
            class="virtual-wrap relation"
            v-if="MediaData.video && MediaData.video.length > 0"
          >
            <h1>Video</h1>
            <div class="virtual-box">
              <div
                class="img-box"
                v-for="(item, index) in MediaData.video.slice(0, 4)"
                :key="index"
                :class="{
                  'margin-top': index >= 2,
                  'margin-top-ipad': index >= 1
                }"
              >
                <img :src="img_url + item.logoUrl" alt="" />
                <span class="VideoBtn" @click="gotoVideo(item)"></span>
              </div>
            </div>
            <img
              class="more"
              @click="showDetailClick('video')"
              src="../assets/img/right-row.png"
              alt=""
            />
          </div>

          <div
            class="site-plan-box relation"
            id="SiteFloorPlan"
            v-if="sitePlanImg && sitePlanImg.length > 0"
          >
            <h1>Site and Floor Plan</h1>
            <div class="img-box">
              <el-image
                v-for="(item, index) in sitePlanImg.slice(0, 4)"
                :key="index"
                :src="img_url + item.img"
                @click="previewImg(sitePlanImg.slice(0, 4), index)"
                :class="{
                  'margin-left': (index - 0 + 1) % 2 == 0,
                  'margin-top': index >= 2,
                  'margin-top-ipad': index >= 1
                }"
              >
                <div slot="error" class="el-error">
                  Load Fail
                </div>
              </el-image>
              <img
                class="more"
                @click="showSiteFloorClick('SiteFloorPlan')"
                src="../assets/img/right-row.png"
                alt=""
              />
            </div>
          </div>

          <div
            class="elevation-chart-box relation"
            id="Elevation"
            v-if="ElevationChartImg && ElevationChartImg.length > 0"
          >
            <h1>Elevation chart</h1>
            <div class="img-box">
              <el-image
                v-for="(item, index) in ElevationChartImg.slice(0, 4)"
                :key="index"
                :src="img_url + item.img"
                @click="previewImg(ElevationChartImg.slice(0, 4), index)"
                :class="{
                  'margin-left': (index - 0 + 1) % 2 == 0,
                  'margin-top': index >= 1,
                  'margin-top-ipad': index >= 1
                }"
              >
                <div slot="error" class="el-error">
                  Load Fail
                </div>
              </el-image>
              <img
                class="more"
                @click="showSiteFloorClick('Elevation')"
                src="../assets/img/right-row.png"
                alt=""
              />
            </div>
          </div>

          <div
            class="facilities-box relation"
            id="Facilities"
            v-if="detailsInfo.facilitiesMap"
          >
            <h1>Nearby Amenities</h1>
            <div
              class="nearby-list-box"
              v-for="(item, index) in nearbyList"
              :key="index"
            >
              <p class="nearby-list-name">
                <span class="nearby-list-mark"></span
                ><span class="nearby-list-text">{{
                  item.type === "subway_station"
                    ? "Mrt Station"
                    : $capitalizeAndRemoveUnderscore(item.type)
                }}</span>
              </p>
              <ul class="nearby-list">
                <li
                  class="nearby-item"
                  v-for="(sitem, sindex) of item.value.slice(0, 5)"
                  :key="sindex"
                >
                  <span>{{ sitem.name }}</span>
                </li>
              </ul>
            </div>
            <img
              class="more"
              @click="showNearbyClick()"
              src="../assets/img/right-row.png"
              alt=""
            />
          </div>

          <div
            class="facilities-box"
            id="Facilities"
            v-else-if="detailsInfo.nearbyAmenities"
          >
            <h1>Nearby Amenities</h1>
            <div
              class="nearby-content"
              v-html="detailsInfo.nearbyAmenities"
            ></div>
          </div>

          <div class="floor-plans-box relation">
            <h1>Floor Plan</h1>
            <div class="plans-box">
              <el-image
                v-for="(item, index) in unitData.slice(0, 4)"
                :key="index"
                :src="img_url + item.img"
                @click="previewImg(unitData.slice(0, 4), index)"
                :class="{
                  'margin-left': (index - 0 + 1) % 2 == 0,
                  'margin-top': index >= 2,
                  'margin-top-ipad': index >= 1
                }"
              >
                <div slot="error">
                  Load Fail
                </div>
              </el-image>
              <!-- <img v-for="(item, index) in unitData" :key="index" :src="img_url + item.img" alt="" :class="{'margin-top': index>=2}"> -->
            </div>
            <img
              class="more"
              @click="showFloorClick()"
              src="../assets/img/right-row.png"
              alt=""
            />
          </div>

          <div class="available-box">
            <h1>Available Units</h1>
            <div class="table-wrap">
              <ul class="table-box">
                <li>
                  <p><span class="align-left font-weight">Type</span></p>
                  <p>
                    <span class="font-weight"
                      >Size({{ projectSet && projectSet.areaUnit1 }})</span
                    >
                  </p>
                  <p><span class="font-weight">Floor Price</span></p>
                  <p><span class="font-weight">#Units</span></p>
                </li>
                <li v-for="(item, index) in statisticsList" :key="index">
                  <p>
                    <span class="align-left">{{ item.type }}</span>
                  </p>
                  <p>
                    <span class="">{{ item.minArea }}-{{ item.maxArea }}</span>
                  </p>
                  <p>
                    <span class="">{{ item.min_price }}</span>
                  </p>
                  <p>
                    <span class="">{{ item.unitNum }}</span>
                  </p>
                </li>
              </ul>
            </div>
            <p class="callMe">Contact me for more information</p>
          </div>

          <div class="avenir-box" v-if="agentData.brokeName !== 'Huttons'">
            <h1>{{ detailsInfo.projectName }}</h1>
            <div class="map-box">
              <div class="map-info">
                <p>District：{{ detailsInfo.location }}</p>
                <p>
                  Address：{{ detailsInfo.streetAddress }},{{
                    detailsInfo.country
                  }}
                  {{ detailsInfo.postalCode }}
                </p>
                <p>
                  Gallery Address：<a
                    href=":javascript"
                    target="_blank"
                    @click="toLink"
                    >{{ detailsInfo.galleryLocation }}</a
                  >
                </p>
              </div>
              <div v-if="detailsInfo.snapshotLogo" class="img-box">
                <img :src="img_url + detailsInfo.snapshotLogo" alt="" />
              </div>
              <!-- <div id="avenir-map"></div> -->
            </div>
          </div>
          <!--  v-if="calcUrl" -->
          <div class="calculator-wrap" v-if="calcUrl" id="Calculator">
            <h1>Calculator</h1>
            <div class="calculator-box">
              <el-button @click="gotoCalculate()">Calculate</el-button>
            </div>
          </div>

          <div class="showflat-box" v-if="agentData.brokeName !== 'Huttons'">
            <h1>View Showflat</h1>
            <div class="showflat-bontent">
              <p>
                Register Or Call Our Sales Hotline
                <span class="phone">{{ agentData.mobile }}</span> for many
                precise information & Priority accessibility for hassle-free
                experiences.
              </p>
              <!-- <p>Enjoy Direct Developer Discount & Non-Obligation Free Consultation！</p> -->
              <p>
                Due to the current situation, it is essential that you contact
                <span class="phone">{{ agentData.mobile }}</span> to confirm
                your showflat appointment.
              </p>
              <p>
                Registered Parties will be eligible for our Immediate Developer
                Appointed Marketing Pricing in addition to live updates of the
                advancement. Submit your Expression of Interest online and be a
                proud owner at the {{ detailsInfo.projectName }}！
              </p>
            </div>
          </div>

          <div class="register-box" id="Register">
            <h1>Register your interest</h1>
            <div class="form-box">
              <p>
                Book an appointment to view {{ detailsInfo.projectName }} show
                flat or send us an inquiry.We will get back to you as soon as
                possible.
              </p>
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="100px"
                class="demo-ruleForm"
                label-position="top"
              >
                <el-row>
                  <el-form-item label="Name" prop="name">
                    <el-input
                      v-model="ruleForm.name"
                      placeholder="Enter your name"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="Phone" prop="phone">
                    <el-input
                      v-model="ruleForm.phone"
                      type="number"
                      placeholder="Enter your mobile number"
                    ></el-input>
                  </el-form-item>
                </el-row>
                <el-row>
                  <el-form-item label="Email" prop="email">
                    <el-input
                      v-model="ruleForm.email"
                      placeholder="Enter your email"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="Remark" prop="remark">
                    <el-input
                      v-model="ruleForm.remark"
                      placeholder="Enter your remark"
                    ></el-input>
                  </el-form-item>
                </el-row>
                <el-form-item class="submit-box">
                  <el-button type="primary" @click="submitForm('ruleForm')"
                    >Submit</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
          </div>

          <div class="videoDIv" v-show="videoShow">
            <div class="video-box">
              <video
                id="video"
                class="videoDom"
                :src="videoUrl"
                controls
                preload="none"
                :poster="logoUrl"
              ></video>
              <span class="closeVideo" @click="closeVideo()">x</span>
            </div>
          </div>

          <footer class="footer">
            <h1>Disclaimer</h1>
            <p v-if="agentData.brokeName === 'Huttons'">
              The information contained on this website is for general
              information purposes only. Huttons Asia Pte Ltd and its affiliates
              ("Huttons") assumes no responsibility for errors or omissions in
              the contents of this website. In no event shall Huttons be liable
              for any special, direct, indirect, consequential, or incidental
              damages or any damages whatsoever, whether in an action of
              contract, negligence or other tort, arising out of or in
              connection with the use of the information provided herein.
              Huttons reserves the right to make additions, deletions, or
              modification to the contents of this website at any time without
              prior notice.
            </p>
            <p v-else-if="agentData.brokeName == 'EcoProp+'">
              The use of EcoProp+ and all associated products and features shall
              be subject to the standard terms of use (
              <a href="https://www.ecoprop.com/terms-of-use" target="_blank"
                >https://www.ecoprop.com/terms-of-use</a
              >
              ), terms of sale (<a
                href="https://www.ecoprop.com/terms-of-sale"
                target="_blank"
                >https://www.ecoprop.com/terms-of-sale</a
              >) and privacy policy (<a
                href="https://www.ecoprop.com/privacy-policy"
                target="_blank"
                >https://www.ecoprop.com/privacy-policy</a
              >).
            </p>
            <p v-else>
              The information contained on this website is for general
              information purposes only. Mixgo Pte Ltd (Company of Ecoprop)
              assumes no responsibility for errors or omissions in the contents
              of this website. In no event shall Ecoprop App be liable for any
              special, direct, indirect, consequential, or incidental damages or
              any damages whatsoever, whether in an action of contract,
              negligence or other tort, arising out of or in connection with the
              use of the information provided herein. Ecoprop App reserves the
              right to make additions, deletions, or modification to the
              contents of this website at any time without prior notice.
            </p>
          </footer>
        </div>
      </div>
    </div>

    <div v-if="showDetail">
      <Gallery
        :detailsInfo="detailsInfo"
        @previewImg="previewMeaiaImg"
        :activeMore="activeName1"
        @hideDetail="hideDetail"
        :MediaData="MediaData"
        :imgUrl="img_url"
      />
    </div>
    <div v-if="showSite">
      <SiteFloorMore
        :detailsInfo="detailsInfo"
        @previewImg="previewImg"
        :activeMore="activeName2"
        @hideDetail="hideDetail"
        :ElevationChartImg="ElevationChartImg"
        :sitePlanImg="sitePlanImg"
        :imgUrl="img_url"
      />
    </div>
    <div v-if="showFloor">
      <FloorPlan
        :detailsInfo="detailsInfo"
        @hideDetail="hideDetail"
        @previewImg="previewImg"
        :RouteInfo="RouteInfo"
        :imgUrl="img_url"
        :brokeName="agentData.brokeName"
      />
    </div>
    <div v-if="showNearby">
      <NearbyAmenities
        @hideDetail="hideDetail"
        :nearbyList="nearbyList"
        :brokeName="agentData.brokeName"
      />
    </div>
  </div>
</template>

<script>
import Gallery from "./shareMobile/galleryMore";
import SiteFloorMore from "./shareMobile/siteFloorMore";
import FloorPlan from "./shareMobile/floorPlan";
import NearbyAmenities from "./shareMobile/nearbyAmenities";
import { ImagePreview } from "vant";
export default {
  components: {
    Gallery,
    SiteFloorMore,
    FloorPlan,
    NearbyAmenities
  },
  data() {
    return {
      menusShow: false,
      RouteInfo: {},
      agentData: {},
      calcUrl: "",
      img_url: "https://img.singmap.com",
      detailsInfo: {},
      statisticsList: [],
      map: null,
      sitePlanImg: [],
      ElevationChartImg: [],
      unitData: [],
      UnitTypeData: [],
      UnitType: "",
      Total: 0,
      active: false,
      activeText: "All Plans",
      MediaData: [],
      videoUrl: "",
      logoUrl: "",
      videoShow: false,
      ruleForm: {
        name: "",
        phone: "",
        email: "",
        remark: ""
      },
      rules: {
        name: [{ required: true, message: "Enter your name", trigger: "blur" }],
        phone: [
          {
            required: true,
            message: "Enter your mobile number",
            trigger: "change"
          }
        ],
        email: [
          { required: true, message: "Enter your email", trigger: "change" },
          {
            type: "email",
            message: "Enter your email",
            trigger: ["blur", "change"]
          }
        ]
      },
      navgatorIndex: "",
      listBoxState: true, //点击导航栏时，暂时停止监听页面滚动
      listBox: [
        "Description",
        "Gallery",
        "SiteFloorPlan",
        "Elevation",
        "Facilities",
        "Calculator",
        "Register"
      ],
      service: null,
      infowindow: null,
      nearbyList: [],
      showDetail: false,
      showSite: false,
      showFloor: false,
      showNearby: false,
      activeName1: "",
      activeName2: "",
      imgList: [],
      backgroundImage: `url(${require("@/assets/img/404.png")})`,
      projectSet: null,
      img_suffix: "",
      defaultImgResize:
        "?x-oss-process=image/auto-orient,1/interlace,1/resize,p_70/quality,q_100"
    };
  },
  created() {
    this.querySysConfig();
    this.RouteInfo = this.$route.query;
    this.$removeScrollNum("newsDetail");
    const head = document.getElementsByTagName("head")[0];
    let link = document.createElement("link");
    link.rel = "canonical";
    link.href = `https://www.ecoprop.com/projectdetail/${this.$route.params.projectName.replaceAll(
      " ",
      "-"
    )}`;
    console.log(link);
    head.appendChild(link);
  },
  activated() {
    this.$SetScroll(this.$refs.newsDetail, "newsDetail");
  },
  mounted() {
    console.log("shareMobile");
    this.getShareParams();
    // this.setGoogleMap()
    this.$KeepScrollTop(this.$refs.newsDetail, "newsDetail");
    // window.addEventListener('scroll', () => {
    //   // 页面滚动停止100毫秒后才会执行下面的函数。
    //   let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    //   if(scrollTop>=80){
    //     document.querySelector(".nav-wrap").style.position = 'fixed'
    //   }else if(scrollTop<80){
    //     document.querySelector(".nav-wrap").style.position = ''
    //   }
    //     this.scrollToTop();
    // } , true);
  },
  destroyed() {
    // window.removeEventListener('scroll', () => {
    //   // 页面滚动停止100毫秒后才会执行下面的函数。
    //   let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    //   if(scrollTop>=80){
    //     document.querySelector(".nav-wrap").style.position = 'fixed'
    //   }else if(scrollTop<80){
    //     document.querySelector(".nav-wrap").style.position = ''
    //   }
    //     this.scrollToTop();
    // } , true);
  },
  computed: {
    whatsapp() {
      let num = "";
      if (this.agentData.mobile) {
        num = parseFloat(this.agentData.mobile.replace(/[^0-9]/gi, ""));
      }
      return num;
    }
  },
  methods: {
    Tolink() {
      //应用市场跳转
      // let isAndroid = navigator.userAgent.match(/Android/i) //g
      // let isIOS = !navigator.userAgent.match(/Android/i) //ios终端
      // if (isAndroid){
      //   window.open(
      //     'https://play.google.com/store/apps/details?id=com.mixgo.ecopropc'
      //   )
      // }else{
      //   window.open('https://apps.apple.com/cn/app/ecoprop/id1574177453')
      // }

      //注册页面跳转
      // if (agentData.userCode) {
      window.open(
        `https://app.mixgo.com/ecop/#/registerActivity?userCode=${
          this.agentData.userCode
        }`
      );
      // } else {
      //   // 没有用户code 处理方案
      // }
    },
    toLink() {
      window.open(
        `https://maps.google.com/maps?q=${this.detailsInfo.galleryLatitude},${
          this.detailsInfo.galleryLongitude
        }`
      );
    },
    getShareParams() {
      let param = this.$route.params;
      this.$Post(this.$api.getShareParams, param).then(res => {
        if (res.code === "0") {
          this.RouteInfo = res.datas;
          this.getEmailSetting();
          this.queryProjectInfo();
          this.unitTypeReport();
          this.querySitePlanImg();
          this.menuFn();
          this.queryProjectMedia();
        }
      });
    },
    initMap(project, gallery) {
      let self = this;
      let pyrmont = new google.maps.LatLng(project.lat, project.lng);
      this.map = new google.maps.Map(document.getElementById("avenir-map"), {
        center: project,
        zoom: 18
      });
      this.service = new google.maps.places.PlacesService(this.map);
      self.infowindow = new google.maps.InfoWindow();

      // let image = ""
      let marker = new google.maps.Marker({
        position: project,
        map: self.map,
        animation: google.maps.Animation.DROP
        // icon: image,
      });
      let marker1 = new google.maps.Marker({
        position: gallery,
        map: self.map,
        animation: google.maps.Animation.DROP
        // icon: image,
      });
    },
    getEmailSetting() {
      let self = this;
      this.$Get(this.$api.getEmailSetting, {
        agentId: self.RouteInfo.agentId
      }).then(res => {
        if (res.code == 0) {
          this.calcUrl = res.datas.calcUrl;
          this.agentData = res.datas;
          if (this.agentData.brokeName === "Huttons") {
            document.getElementById("wrap").className = "themeHuttons";
          } else {
            document.getElementById("wrap").className = "themeEcoprop";
          }
          this.agentData.signature =
            res.datas.signature &&
            this.agentData.signature.split("\n").join("<br>");
        }
      });
    },

    querySysConfig() {
      this.$Get(this.$api.querySysConfig, {}).then(res => {
        if (res.code == 0) {
          this.img_url = res.datas.img_url;
          this.img_suffix = res.datas["img_resize_other_app"];
        }
      });
    },
    queryProjectInfo() {
      let self = this;
      this.$Get(this.$api.queryProjectInfo, self.RouteInfo).then(res => {
        if (res.code == 0) {
          self.detailsInfo = res.datas;
          window.document.title = self.detailsInfo.projectName;
          const head = document.getElementsByTagName("head")[0];
          let link = document.createElement("link");
          link.rel = "canonical";
          link.href = `https://www.ecoprop.com/projectdetail/${self.$route.params.projectName.replaceAll(
            " ",
            "-"
          )}`;
          console.log(link);
          head.appendChild(link);
          const regex = new RegExp("<img", "gi");
          // console.log(Base64.decode(res.datas.description))
          self.detailsInfo.description = Base64.decode(
            res.datas.description
          ).replace(regex, `<img style="max-width: 100%;"`);
          if (res.datas.facilities)
            self.detailsInfo.facilities = Base64.decode(res.datas.facilities);
          if (res.datas.nearbyAmenities)
            this.detailsInfo.nearbyAmenities = Base64.decode(
              res.datas.nearbyAmenities
            );
          if (res.datas.facilitiesMap)
            self.nearbyList = JSON.parse(res.datas.facilitiesMap);
          // self.initMap({
          //   lat: Number(self.detailsInfo.latitude),
          //   lng: Number(self.detailsInfo.longitude)
          // }, {
          //   lat: Number(self.detailsInfo.galleryLatitude),
          //   lng: Number(self.detailsInfo.galleryLongitude)
          // });
          // this.$GetFn('https://maps.googleapis.com/maps/api/place/nearbysearch/json', data)
          // .then(res=>{
          //   console.log(res)
          // })
        }
      });
    },
    getFalities() {},
    async unitTypeReport() {
      const projectSetRes = await this.$Get(this.$api.getProjectSetById, {
        projectId: this.RouteInfo.projectId
      });
      if (projectSetRes.code === "0") {
        this.projectSet = projectSetRes.datas;
      }

      const res = await this.$Get(this.$api.unitTypeReport, {
        projectId: this.RouteInfo.projectId,
        agentId: this.RouteInfo.agentId
      });
      if (res.code == 0) {
        this.statisticsList = res.datas;
      }
    },
    setGoogleMap() {
      let head = document.head || document.getElementsByTagName("head")[0];
      let scriptDiv = document.createElement("script"); //  AIzaSyAxuq9fNMvpfLt8gwUa1o9djUYr3XwIw8I
      scriptDiv.src =
        "https://maps.googleapis.com/maps/api/js?key=AIzaSyBFhANESE0lhBp-tSPbOy8FI6FfIiuPR0s&libraries=places";
      head.appendChild(scriptDiv);
    },
    querySitePlanImg() {
      this.$Post(this.$api.querySitePlanImg, this.RouteInfo).then(res => {
        if (res.code == 0) {
          this.ElevationChartImg = [];
          this.sitePlanImg = [];
          res.datas.forEach(ele => {
            if (ele.sitePlanName === "Elevation Chart") {
              this.ElevationChartImg.push(ele);
            } else if (ele.sitePlanName === "Site Plan") {
              this.sitePlanImg.push(ele);
            }
          });
        }
      });
    },
    menuFn() {
      let data = {
        type: "",
        projectId: this.RouteInfo.projectId,
        pageNo: 1,
        pageSize: 9999
      };
      this.$Post(this.$api.queryFloorPlansByType, data, true).then(res => {
        if (res.code == 0) {
          this.Total = res.datas.count;
          this.unitData = res.datas.lists;
        }
      });
    },
    showDropdown() {
      this.active = !this.active;
    },
    selectUnitType(type) {
      this.activeText = type;
      this.active = false;
      this.menuFn(type);
    },
    queryProjectMedia() {
      this.$Post(this.$api.queryProjectMedia, this.RouteInfo, true).then(
        res => {
          if (res.code == 0) {
            this.MediaData = res.datas;
            let imgList = [];
            this.MediaData.img.forEach(ele => {
              imgList.push(this.img_url + ele.url);
            });
            this.imgList = imgList;
            console.log(this.imgList);
          }
        }
      );
    },
    goFileLink(item) {
      window.open(item.link);
    },
    gotoVideo(item) {
      let video = document.getElementById("video");
      if (item.url.includes("https")) {
        window.open(item.url);
      } else {
        this.videoUrl = this.img_url + item.url;
        this.logoUrl = this.img_url + item.logoUrl;
        this.videoShow = true;
        video.load();
      }
    },
    closeVideo() {
      let videoElement = document.getElementById("video");
      videoElement.pause();
      this.videoShow = false;
    },
    gotoCalculate() {
      window.open(this.calcUrl);
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let data = {
            ...this.ruleForm,
            ...this.RouteInfo
          };
          this.$Post(this.$api.sendEmailToAgent, data, true).then(res => {
            if (res.code == 0) {
              this.$dialog
                .alert({
                  title: "Succeed",
                  message:
                    "Information submitted successfully, we will contact you as soon as possible!",
                  confirmButtonText: "OK"
                })
                .then(() => {});
            } else {
              this.$dialog
                .alert({
                  title: "Error",
                  message:
                    "Information submission failed, the server is busy, please submit later!",
                  confirmButtonText: "OK"
                })
                .then(() => {});
            }
          });
        } else {
          return false;
        }
      });
    },
    // 点击导航菜单，页面滚动到指定位置
    toScroll(id) {
      this.navgatorIndex = id;

      // this.$el.querySelector(`#${id}`).scrollIntoView({
      //   behavior: "smooth",  // 平滑过渡
      //   block:    "start"  // 上边框与视窗顶部平齐。默认值
      // });
      var PageId = document.querySelector(`#${id}`);
      window.scrollTo({
        top: PageId.offsetTop - 100,
        behavior: "smooth"
      });
      // console.log(document.getElementById(`${id}`).offsetTop)
      // document.documentElement.scrollTop = documnet.getElementById(`${id}`).offsetTop
      this.listBoxState = false;
      let timeId;
      clearTimeout(timeId);
      timeId = setTimeout(() => {
        this.listBoxState = true;
      }, 200);
    },
    // 监听页面元素滚动，改变导航栏选中
    scrollToTop() {
      // 获取视窗高度
      var domHight = document.body.offsetHeight;
      // dom滚动位置
      var scrollTop =
        (window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop) + 100;

      if (this.listBoxState) {
        //作用是点击导航栏时，延迟这里执行。
        this.listBox.map((v, i) => {
          // 获取监听元素距离视窗顶部距离
          var offsetTop =
            document.getElementById(`${v}`) &&
            document.getElementById(`${v}`).offsetTop;
          // 获取监听元素本身高度
          var scrollHeight =
            document.getElementById(`${v}`) &&
            document.getElementById(`${v}`).scrollHeight;

          // 如果 dom滚动位置 >= 元素距离视窗距离 && dom滚动位置 <= 元素距离视窗距离+元素本身高度
          // 则表示页面已经滚动到可视区了。
          if (scrollTop >= offsetTop && scrollTop <= offsetTop + scrollHeight) {
            // 导航栏背景色选中
            this.navgatorIndex = v;
          }
        });
      }
    },
    // toScroll(item){
    //   let scrollToContainer = document.querySelector(item)
    //   let scrollBody = document.querySelector("#wrap")
    //   console.log(scrollToContainer.offsetTop - scrollBody.offsetTop)
    //   scrollBody.animate({
    //       scrollTop: scrollToContainer.offsetTop - scrollBody.offsetTop
    //     }, 2000);//2秒滑动到指定位置
    //   }

    hideDetail(name) {
      this[name] = false;
      // this.showDetail = false
      // this.showSite = false
    },
    showDetailClick(activeName) {
      this.activeName1 = activeName;
      this.showDetail = true;
    },
    showSiteFloorClick(activeName) {
      this.showSite = true;
      this.activeName2 = activeName;
    },
    showFloorClick() {
      this.showFloor = true;
    },
    showNearbyClick() {
      console.log(this.nearbyList);
      this.showNearby = true;
    },
    /**
     * 预览媒体图片
     */
    previewMeaiaImg(list, index) {
      let images = [];
      list.forEach(ele => {
        images.push(this.img_url + ele.url);
      });
      ImagePreview({
        images: images,
        startPosition: index,
        closeable: true
      });
    },
    previewImg(list, index) {
      let images = [];
      list.forEach(ele => {
        images.push(this.img_url + ele.img);
      });
      ImagePreview({
        images: images,
        startPosition: index,
        closeable: true
      });
    }
  }
};
</script>

<style lang="less" scoped>
html,
body {
  font-family: Montserrat-Regular, Montserrat;
  font-size: 12px;
}
h1 {
  font-size: 16px;
}
h2 {
  font-size: 14px;
}
p {
  margin: 0;
}
.relation {
  position: relative;
  .more {
    position: absolute;
    top: 0;
    right: 0;
    width: 0.22rem;
  }
}
.margin-left {
  margin-left: 0.1rem;
}
.themeHuttons {
  .theme(#041e42, #041e42);
}
.themeEcoprop {
  .theme(#0f206c, #0f206c);
}
.theme(@backcolor:#0f206c,@fcolor:#0f206c) {
  .head {
    position: relative;
    z-index: 100;
    height: 50px;
    .defaultNav {
      .van-icon,
      .van-nav-bar__text {
        color: #000;
      }
    }
  }
  .app-pop {
    position: fixed;
    top: 45px;
    left: 0;
    right: 0;
    z-index: 100;
    display: flex;
    align-items: center;
    padding: 0 20px;
    height: 0.55rem;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.5);
    .app-right {
      margin-left: 8px;
      display: flex;
      justify-content: space-between;
      p {
        color: #fff;
        font-size: 10px;
      }
      div {
        padding: 0 8px;
        background: linear-gradient(180deg, #ff5c3d 0%, #ff2a5f 100%);
        border-radius: 19px;
        font-size: 9px;
        font-weight: 500;
        color: #ffffff;
        flex: none;
        display: flex;
        align-items: center;
      }
    }
  }
  .top {
    position: fixed;
    top: 45px;
    left: 0;
    right: 0;
    z-index: 99;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    height: 0.55rem;
    overflow: hidden;
    background: #fff;
    box-shadow: 0px 1px 15px 0px rgba(20, 15, 38, 0.1);
    .logo-box {
      display: flex;
      .logo {
        height: 0.5rem;
      }
      span {
        line-height: 0.55rem;
        margin-left: 0.1rem;
        color: #140f26;
        font-size: 0.1rem;
      }
    }
    .menus {
      width: 16px;
      height: 16px;
    }
  }
  .agent-info-wrap {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 99;
    height: 0.8rem;
    background: #fff;
    box-shadow: 0px -1px 15px 0px rgba(20, 15, 38, 0.1);
    .agent-info-box {
      padding: 0 0.25rem;
      height: 0.8rem;
      color: #666;
      display: flex;
      align-items: center;
      .agent-headshot {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: 0 0;
      }
      .agent-info {
        margin-left: 0.15rem;
        .agent-name {
          font-weight: 600;
        }
        .regnum {
          margin: 0.05rem 0;
        }
        .mobile-box {
          display: flex;
          .agent-mobile {
            cursor: pointer;
            display: flex;
            align-items: center;
            a {
              color: #666;
            }
            .mobile-img {
              width: 20px;
              margin-right: 5px;
              height: 20px;
              background: url(../assets/img/mobile@2x.png) no-repeat center;
              background-size: cover;
            }
            .email-img {
              width: 20px;
              margin-left: 10px;
              height: 20px;
              margin-right: 5px;
              background: url(../assets/img/email@2x.png) no-repeat center;
              background-size: cover;
            }
            .whatsapp-img {
              margin-left: 10px;
              width: 20px;
              height: 20px;
              margin-right: 5px;
              background: url(../assets/img/whatsapp@2x.png) no-repeat center;
              background-size: cover;
            }
          }
          .agent-mobile:hover,
          .agent-mobile:active {
            .mobile-img {
              background-image: url(../assets/img/mobiled@2x.png);
            }
            a {
              color: @backcolor;
            }
            .email-img {
              background-image: url(../assets/img/emailed@2x.png);
            }
            .whatsapp-img {
              background-image: url(../assets/img/whatsappd@2x.png);
            }
          }
        }
      }
    }
  }
  .menus-mask {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 100;
    .close-menus {
      float: left;
      height: 100%;
      width: 175px;
    }
    .menu-list {
      position: relative;
      z-index: 101;
      padding-top: 60px;
      width: 200px;
      height: 100%;
      background: #fff;
      float: right;
      border-radius: 10px 0 0 10px;
      box-sizing: border-box;
      .menu-item {
        height: 40px;
        line-height: 40px;
        text-indent: 25px;
      }
      .active {
        background: @backcolor;
        color: #fff;
        font-weight: 600;
      }
    }
  }
  .content-wrap {
    position: absolute;
    top: 100px;
    left: 0;
    right: 0;
    min-height: 86.9vh;
    padding-bottom: 0.8rem;
    .main-img-box {
      position: relative;
      height: 33.7vh;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      overflow: hidden;
      .project-name {
        text-align: center;
        margin-top: 0.2rem;
        font-size: 20px;
        font-family: Montserrat-Black, Montserrat;
        font-weight: 900;
        color: #ffffff;
      }
    }
    .main {
      width: 100%;
      padding: 0 0.2rem;
      overflow-x: hidden;
      box-sizing: border-box;
      .description-box {
        padding-bottom: 0.15rem;
        border-bottom: 1px solid rgba(108, 123, 138, 1);
        h1 {
          font-size: 16px;
        }
        .descriptionDiv {
          color: #6c7b8a;
          font-family: Montserrat-Regular, Montserrat;
          img {
            width: 80% !important;
          }
        }
      }
      .client-box {
        padding-bottom: 0.15rem;
        border-bottom: 1px solid rgba(108, 123, 138, 1);
        .client-content {
          font-size: 12px;
          color: rgba(108, 123, 138, 1);
        }
        .van-row {
          font-size: 12px;
          .van-col--6 {
            color: rgba(108, 123, 138, 1);
          }
          .van-col--14 {
            color: rgba(20, 15, 38, 1);
          }
        }
      }
      .gallery-box {
        padding-bottom: 0.15rem;
        border-bottom: 1px solid rgba(108, 123, 138, 1);
        .img-box {
          .el-image {
            width: 1.62rem;
            height: 1.3rem;
            border-radius: 15px;
            .el-error {
              width: 100%;
              height: 100%;
              display: flex;
              vertical-align: middle;
              justify-content: center;
              align-items: center;
              font-size: 14px;
              color: #c0c4cc;
              background: #f5f7fa;
            }
          }
          .margin-left {
            margin-left: 0.1rem;
          }
          .margin-top {
            margin-top: 0.1rem;
          }
        }
      }
      .virtual-wrap {
        padding-bottom: 0.15rem;
        border-bottom: 1px solid rgba(108, 123, 138, 1);
        .virtual-box {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          .img-box {
            width: 1.62rem;
            height: 1.3rem;
            position: relative;
            img {
              width: 1.62rem;
              height: 1.3rem;
              border-radius: 15px;
            }
            .iconSpn {
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              width: 0.3rem;
              height: 0.3rem;
              display: inline-block;
              background: url("../assets/img/virtual.png") no-repeat 0 0;
              background-size: 100% 100%;
            }
            .VideoBtn {
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              width: 0.3rem;
              height: 0.3rem;
              display: inline-block;
              background: url("../assets/img/video.png") no-repeat 0 0;
              background-size: 100% 100%;
            }
          }
          .margin-top {
            margin-top: 0.1rem;
          }
        }
      }

      .site-plan-box,
      .elevation-chart-box {
        padding-bottom: 0.15rem;
        border-bottom: 1px solid rgba(108, 123, 138, 1);
        /deep/.img-box {
          .el-image {
            width: 1.62rem;
            height: 1.3rem;
            border-radius: 15px;
            .el-error {
              width: 100%;
              height: 100%;
              display: flex;
              vertical-align: middle;
              justify-content: center;
              align-items: center;
              font-size: 14px;
              color: #c0c4cc;
              background: #f5f7fa;
            }
          }
          .margin-top {
            margin-top: 0.1rem;
          }
        }
      }

      .facilities-box {
        padding-bottom: 0.15rem;
        border-bottom: 1px solid rgba(108, 123, 138, 1);
        .nearby-list-box {
          .nearby-list-name {
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            .nearby-list-mark {
              display: inline-block;
              width: 14px;
              height: 14px;
              background: @backcolor;
              border-radius: 1px;
              margin-right: 5px;
            }
            .nearby-list-text {
              font-size: 0.12rem;
              font-weight: 600;
            }
          }
          .nearby-list {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            .nearby-item {
              padding-right: 0.3rem;
              margin-bottom: 0.2rem;
              font-size: 0.12rem;
              font-family: Montserrat-Medium, Montserrat;
              font-weight: 500;
              color: #333333;
              line-height: 19px;
            }
          }
        }
        .nearby-content {
          overflow-x: auto;
        }
      }
      .floor-plans-box {
        padding-bottom: 0.15rem;
        border-bottom: 1px solid rgba(108, 123, 138, 1);
        .plans-box {
          .el-image {
            width: 1.62rem;
            height: 1.3rem;
            border-radius: 15px;
            .el-error {
              width: 100%;
              height: 100%;
              display: flex;
              vertical-align: middle;
              justify-content: center;
              align-items: center;
              font-size: 14px;
              color: #c0c4cc;
              background: #f5f7fa;
            }
          }
          .margin-top {
            margin-top: 0.1rem;
          }
        }
      }

      .available-box {
        padding-bottom: 0.15rem;
        border-bottom: 1px solid rgba(108, 123, 138, 1);
        .table-wrap {
          background: #fff;
          border-top: 1px solid #eee;
          border-left: 1px solid #eee;
          .table-box {
            width: 100%;
            li {
              display: flex;
              p {
                display: flex;
                align-items: center;
                justify-content: center;
                min-height: 30px;
                border-right: 1px solid #eee;
                border-bottom: 1px solid #eee;
              }
              .align-left {
                text-align: center;
                width: 1rem;
              }
              p {
                flex: 1;
              }
              span.font-weight {
                font-weight: 600;
              }
            }
          }
        }
        .callMe {
          margin-top: 0.1rem;
          height: 11px;
          font-size: 0.12rem;
          font-weight: bold;
          color: @fcolor;
          line-height: 11px;
        }
      }

      .avenir-box {
        padding-bottom: 0.15rem;
        border-bottom: 1px solid rgba(108, 123, 138, 1);
        .map-box {
          background: #fff;
          display: flex;
          .map-info {
            flex: 1;
            p {
              word-wrap: break-word;
              margin-top: 0.05rem;
              color: rgba(102, 102, 102, 1);
            }
            .font-weight {
              font-weight: 600;
              color: rgba(51, 51, 51, 1);
            }
            .margin-top {
              margin-top: 0.15rem;
            }
          }
          #avenir-map {
            width: 1.82rem;
            height: 1.1rem;
          }
          .img-box {
            margin-left: 0.1rem;
            img {
              height: 1.1rem;
            }
          }
        }
      }

      .calculator-wrap {
        padding-bottom: 0.15rem;
        border-bottom: 1px solid rgba(108, 123, 138, 1);
        /deep/.calculator-box {
          display: flex;
          justify-content: center;
          .el-button {
            width: 2.78rem;
            height: 5vh;
            border-radius: 0.1rem;
            color: @fcolor;
            font-size: 0.12rem;
            font-weight: 600;
            border: 1px solid @backcolor;
          }
        }
      }

      .showflat-box {
        padding-bottom: 0.15rem;
        border-bottom: 1px solid rgba(108, 123, 138, 1);
        overflow: hidden;
        .showflat-bontent {
          color: rgba(51, 51, 51, 1);
          p {
            margin: 15px 0px;
            .phone {
              color: @fcolor;
            }
          }
        }
      }

      .register-box {
        border-bottom: 1px solid rgba(108, 123, 138, 1);
        /deep/.form-box {
          background: #fff;
          font-weight: 600;
          .el-form {
            .el-row {
              .el-form-item {
                width: 3.35rem;
                .el-form-item__label {
                  font-weight: 600;
                  color: #333;
                  font-size: 0.12rem;
                }
                .el-form-item__content {
                  .el-input {
                    .el-input__inner {
                      background: #f7f7f7;
                      border-radius: 10px;
                      height: 50px;
                      border-color: #fff;
                    }
                  }
                }
              }
            }
            .submit-box {
              text-align: center;
              .el-button {
                width: 2.78rem;
                height: 5vh;
                font-size: 0.12rem;
                border-radius: 10px;
                background: #fff;
                color: @fcolor;
                font-weight: 600;
                border: 1px solid @backcolor;
              }
            }
          }
        }
      }

      .videoDIv {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 101;
        background: rgba(0, 0, 0, 0.5);
        .video-box {
          position: relative;
          #video {
            width: 3rem;
          }
          .closeVideo {
            position: absolute;
            top: 5px;
            right: 10px;
            color: #fff;
            cursor: pointer;
            font-size: 30px;
          }
        }
      }

      .footer {
        overflow: hidden;
        p {
          color: rgba(51, 51, 51, 1);
          margin: 20px auto;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/shareMobile.vue